import React from 'react'
import PropTypes from 'prop-types'

import { H4 } from 'components/Text'

import {
  MenuContainer,
  Photo,
  DetailsSection,
  Price,
  Description,
  Divider,
  InnerContainer,
} from './styled'

class MenuItem extends React.PureComponent {
  pickMenu = () => {
    this.props.openModal(this.props.menu)
  }

  render() {
    const { orders, menu } = this.props
    const { id, name, description, thumb, price } = menu
    const isActive = orders.includes(id)
    return (
      <MenuContainer isActive={isActive} onClick={this.pickMenu}>
        <InnerContainer>
          <DetailsSection>
            <H4>{name}</H4>
            {description && <Description>{description}</Description>}
            <Price light>{price}</Price>
          </DetailsSection>
          {thumb && <Photo image={thumb} />}
        </InnerContainer>
        <Divider />
      </MenuContainer>
    )
  }
}

MenuItem.propTypes = {
  orders: PropTypes.array,
  menu: PropTypes.object.isRequired,
  openModal: PropTypes.func.isRequired,
}

export default MenuItem
